'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _underscore = require('../utils/underscore');

var _ComponentWithPartials = require('../mixins/ComponentWithPartials');

var _ComponentWithPartials2 = _interopRequireDefault(_ComponentWithPartials);

var _Controllable = require('../decorators/Controllable');

var _Controllable2 = _interopRequireDefault(_Controllable);

var _OptionTypes = require('../types/OptionTypes');

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactUtils = require('react-utils');

var _SyntheticEvent = require('../core/SyntheticEvent');

var _SyntheticEvent2 = _interopRequireDefault(_SyntheticEvent);

var _UITypeaheadUtils = require('./UITypeaheadUtils');

var _UITypeaheadResults = require('./results/UITypeaheadResults');

var _UITypeaheadResults2 = _interopRequireDefault(_UITypeaheadResults);

var _UITypeaheadResultsGroup = require('./results/UITypeaheadResultsGroup');

var _UITypeaheadResultsGroup2 = _interopRequireDefault(_UITypeaheadResultsGroup);

var _UITypeaheadResultsItem = require('./results/UITypeaheadResultsItem');

var _UITypeaheadResultsItem2 = _interopRequireDefault(_UITypeaheadResultsItem);

var _UITypeaheadSearch = require('./search/UITypeaheadSearch');

var _UITypeaheadSearch2 = _interopRequireDefault(_UITypeaheadSearch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UIGroupedTypeahead = _react2.default.createClass({
  displayName: 'UIGroupedTypeahead',

  mixins: [_ComponentWithPartials2.default, _reactAddonsPureRenderMixin2.default],

  propTypes: {
    autoFilter: _react.PropTypes.bool,
    minimumSearchCount: _react.PropTypes.number,
    onChange: _react.PropTypes.func,
    onSearchChange: _react.PropTypes.func,
    options: _react.PropTypes.arrayOf(_OptionTypes.OptionGroupType.isRequired).isRequired,
    placeholder: _react.PropTypes.string,
    search: _react.PropTypes.string,
    value: _react.PropTypes.string
  },

  getDefaultProps: function getDefaultProps() {
    return {
      autoFilter: true,
      minimumSearchCount: 0,
      search: ''
    };
  },
  getInitialState: function getInitialState() {
    var _props = this.props,
        autoFilter = _props.autoFilter,
        search = _props.search;

    return {
      highlighted: this.getInitialHighlighted(),
      searchRegex: autoFilter ? (0, _UITypeaheadUtils.getSearchRegExp)(search) : undefined
    };
  },
  componentWillReceiveProps: function componentWillReceiveProps(_ref) {
    var autoFilter = _ref.autoFilter,
        search = _ref.search;

    if (autoFilter && !(0, _underscore.isEqual)(search, this.props.search)) {
      this.setState({ searchRegex: (0, _UITypeaheadUtils.getSearchRegExp)(search) });
    }
  },
  componentDidUpdate: function componentDidUpdate() {
    var highlightedNode = (0, _reactDom.findDOMNode)(this.refs.highlighted);
    if (highlightedNode == null) {
      return;
    }

    var parent = highlightedNode.parentElement.parentElement;
    var offsetTop = highlightedNode.offsetTop;
    var scrollTop = parent.scrollTop;

    if (scrollTop > offsetTop) {
      parent.scrollTop = 0;
      return;
    }

    var nodeBottom = highlightedNode.offsetHeight + offsetTop;
    var parentBottom = scrollTop + parent.offsetHeight;

    if (parentBottom < nodeBottom) {
      parent.scrollTop = scrollTop + nodeBottom - parentBottom;
    }
  },
  focus: function focus() {
    if (this._searchRef) {
      this._searchRef.focus();
    }
  },
  select: function select() {
    if (this._searchRef) {
      this._searchRef.select();
    }
  },
  getEmptyGroupOption: function getEmptyGroupOption(group) {
    if (group.emptyMessage) {
      return _extends({}, (0, _UITypeaheadUtils.getEmptyGroup)(), { text: group.emptyMessage });
    }

    return (0, _UITypeaheadUtils.getEmptyGroup)();
  },
  getFilteredOptions: function getFilteredOptions(options) {
    if (!this.state || !this.state.searchRegex) {
      return options;
    }

    var searchRegex = this.state.searchRegex;

    return options.filter(function (_ref2) {
      var dropdownText = _ref2.dropdownText,
          text = _ref2.text,
          value = _ref2.value;
      return searchRegex.test(text) || searchRegex.test('' + value) || typeof dropdownText === 'string' && searchRegex.test(dropdownText);
    });
  },
  getFirstValidOption: function getFirstValidOption(group) {
    var options = this.getFilteredOptions(group.options);
    if (!options) {
      return null;
    }

    for (var i = 0; i < options.length; i++) {
      if (!options[i].disabled) {
        return options[i];
      }
    }
    return null;
  },
  getHighlightedIndexes: function getHighlightedIndexes() {
    var options = this.props.options;
    var highlighted = this.state.highlighted;

    for (var i = 0; i < options.length; i++) {
      var group = options[i];

      for (var j = 0; j < group.options.length; j++) {
        var groupOption = group.options[j];

        if (highlighted === groupOption) {
          return {
            groupIdx: i,
            optionIdx: j
          };
        }
      } // end for each option
    } // end for each group

    return {};
  },
  getInitialHighlighted: function getInitialHighlighted() {
    var _props2 = this.props,
        options = _props2.options,
        value = _props2.value;

    var groupLength = options.length;

    if (value) {
      for (var i = 0; i < groupLength; i++) {
        var group = this.props.options[i];

        for (var j = 0; j < group.options.length; j++) {
          var option = group.options[j];

          if (option.value === value) {
            return option;
          }
        } // end for each option
      } // end for each group
    }

    for (var _i = 0; _i < groupLength; _i++) {
      var highlighted = this.getFirstValidOption(options[_i]);

      if (highlighted) {
        return highlighted;
      }
    }

    return null;
  },
  getSearchCount: function getSearchCount() {
    var count = this.props.options.reduce(function (cnt, group) {
      return Math.max(cnt, group.options.length);
    }, 0);

    return count;
  },
  handleChange: function handleChange(option, evt) {
    if (option.disabled) {
      return;
    }

    this.handleHighlight(option);
    var onChange = this.props.onChange;

    onChange((0, _SyntheticEvent2.default)(option.value, evt));
  },
  handleHighlight: function handleHighlight(option, resetScroll) {
    if (this.state.highlighted === option) {
      return;
    }

    if (resetScroll) {
      var highlightedNode = (0, _reactDom.findDOMNode)(this.refs.highlighted);
      if (highlightedNode != null) {
        highlightedNode.parentElement.parentElement.scrollTop = 0;
      }
    }

    this.setState({ highlighted: option });
  },
  handleKeyDown: function handleKeyDown(evt) {
    var index = this.getHighlightedIndexes();

    switch (evt.key) {
      case 'ArrowLeft':
        evt.preventDefault();
        this.keyLeft(index);
        break;
      case 'ArrowRight':
        evt.preventDefault();
        this.keyRight(index);
        break;
      case 'ArrowUp':
        evt.preventDefault();
        this.keyUp(index);
        break;
      case 'ArrowDown':
        evt.preventDefault();
        this.keyDown(index);
        break;
      case 'Enter':
        evt.preventDefault();
        this.keyEnter();
        break;
      default:
        break;
    }
  },
  isHighlighted: function isHighlighted(option) {
    var highlighted = this.state.highlighted;
    if (highlighted) {
      return option === highlighted;
    }

    var value = option.value;
    if (this.props.hasOwnProperty('value')) {
      return this.props.value === value;
    }

    return this.state.value === value;
  },
  keyDown: function keyDown(_ref3) {
    var groupIdx = _ref3.groupIdx,
        optionIdx = _ref3.optionIdx;

    var group = this.props.options[groupIdx];
    var optionLength = group.options.length;
    var optIdx = optionIdx + 1;

    while (optIdx < optionLength) {
      var option = group.options[optIdx];

      if (option.disabled) {
        optIdx++;
      } else {
        this.handleHighlight(option, false);
        break;
      }
    }
  },
  keyEnter: function keyEnter() {
    this.handleChange(this.state.highlighted);
  },
  keyLeft: function keyLeft(_ref4) {
    var groupIdx = _ref4.groupIdx;

    var grpIdx = groupIdx - 1;

    while (grpIdx >= 0) {
      var group = this.props.options[grpIdx];
      var option = this.getFirstValidOption(group);

      if (option) {
        this.handleHighlight(option, true);
        break;
      }

      grpIdx--;
    }
  },
  keyRight: function keyRight(_ref5) {
    var groupIdx = _ref5.groupIdx;

    var groupLength = this.props.options.length;
    var grpIdx = groupIdx + 1;

    while (grpIdx < groupLength) {
      var group = this.props.options[grpIdx];
      var option = this.getFirstValidOption(group);

      if (option) {
        this.handleHighlight(option, true);
        break;
      }

      grpIdx++;
    }
  },
  keyUp: function keyUp(_ref6) {
    var groupIdx = _ref6.groupIdx,
        optionIdx = _ref6.optionIdx;

    var group = this.props.options[groupIdx];
    var optIdx = optionIdx - 1;

    while (optIdx >= 0) {
      var option = group.options[optIdx];

      if (option.disabled) {
        optIdx--;
      } else {
        this.handleHighlight(option, false);
        break;
      }
    }
  },
  searchRefCallback: function searchRefCallback(ref) {
    this._searchRef = ref;
  },
  renderResultGroups: function renderResultGroups() {
    var _this = this;

    var groups = [];

    this.props.options.forEach(function (group, i) {
      var results = null;

      if (group.options.length === 0) {
        results = _this.renderResultsEmpty(_this.getEmptyGroupOption(group), !!group.emptyMessage);
      } else {
        var options = _this.getFilteredOptions(group.options);

        if (options.length === 0) {
          results = _this.renderResultsEmpty((0, _UITypeaheadUtils.getNoMatchesOption)());
        } else {
          results = options.map(function (option) {
            return _this.renderResultsItem(option);
          });
        }
      }

      groups.push(_react2.default.createElement(
        _UITypeaheadResultsGroup2.default,
        { group: group, key: group.value || i },
        results
      ));
    });

    return groups;
  },
  renderResultsItem: function renderResultsItem(option) {
    var isHighlighted = this.isHighlighted(option);
    var searchRegex = this.state.searchRegex;

    return _react2.default.createElement(_UITypeaheadResultsItem2.default, {
      highlighted: isHighlighted,
      key: option.value,
      onClick: this.partial(this.handleChange, option),
      onMouseEnter: this.partial(this.handleHighlight, option, false),
      option: option,
      ref: isHighlighted ? 'highlighted' : undefined,
      search: searchRegex
    });
  },
  renderResultsEmpty: function renderResultsEmpty(option, isMessage) {
    return _react2.default.createElement(_UITypeaheadResultsItem2.default, {
      disabled: true,
      key: option.value,
      message: isMessage,
      option: option
    });
  },
  renderSearch: function renderSearch(_ref7) {
    var onSearchChange = _ref7.onSearchChange,
        placeholder = _ref7.placeholder,
        search = _ref7.search;

    return _react2.default.createElement(_UITypeaheadSearch2.default, {
      onChange: onSearchChange,
      onKeyDown: this.handleKeyDown,
      placeholder: placeholder,
      value: search,
      ref: this.searchRefCallback
    });
  },
  render: function render() {
    var _props3 = this.props,
        minimumSearchCount = _props3.minimumSearchCount,
        onSearchChange = _props3.onSearchChange,
        placeholder = _props3.placeholder,
        search = _props3.search;


    var computedClassName = (0, _reactUtils.classNames)('private-dropdown', 'private-typeahead', 'layout-grouped', { 'hide-search': this.getSearchCount() < minimumSearchCount });

    var renderedSearch = this.renderSearch({
      onSearchChange: onSearchChange,
      placeholder: placeholder,
      search: search
    });

    return _react2.default.createElement(
      'div',
      { className: computedClassName },
      renderedSearch,
      _react2.default.createElement(
        _UITypeaheadResults2.default,
        null,
        this.renderResultGroups()
      )
    );
  }
});

exports.default = (0, _Controllable2.default)(UIGroupedTypeahead, ['search', 'value']);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1282/js/typeahead/UIGroupedTypeahead.js
// module id = 322
// module chunks = 0